import { render, staticRenderFns } from "./Bop.vue?vue&type=template&id=234f8d2c&scoped=true"
import script from "./Bop.vue?vue&type=script&lang=ts"
export * from "./Bop.vue?vue&type=script&lang=ts"
import style0 from "./Bop.vue?vue&type=style&index=0&id=234f8d2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f8d2c",
  null
  
)

export default component.exports